module.exports = {
    /**
     * 数字格式化：万、亿单位
     * @param {*} val 
     * @returns 
     */
    numberFormat(val_,type) {
        function strNumSize(tempNum) {
            let stringNum = tempNum.toString()
            let index = stringNum.indexOf(".")
            let newNum = stringNum;
            if (index != -1) {
                newNum = stringNum.substring(0, index)
            }
            return newNum.length
        }
        if (!val_) { return 0; }
        let m = {
            num: 0,
            unit: ""
        }
        let num = Number(val_)
        if (num <= 1) {
            m.num = num;
            m.unit = '元';
            if(type){
                return num[type];
            }else{
                return m.num+m.unit;
            }
        };
        let moneyUnits = ["元", "万元", "亿元", "万亿"]
        let dividend = 10000;
        let curentNum = num;
        //转换数字 
        let curentUnit = moneyUnits[0];
        //转换单位 
        for (let i = 0; i < 4; i++) {
            curentUnit = moneyUnits[i]
            if (strNumSize(curentNum) < 5) {
                break;
            }
            curentNum = curentNum / dividend
        }
        m.num = Number(curentNum)
        m.unit = curentUnit;
        if(type){
            return m[type];
        }else{
            return m.num+m.unit;
        }
    },
    //时间戳转年月日
    timestrFormat(time_, type) {
        if(!time_){return '';}
        const time = new Date(time_);
        let Y = time.getFullYear();
        let M = time.getMonth();
        M = (M + 1) < 10 ? '0' + (M + 1) : (M + 1);  //这里月份加1的原因是因为月份是从0开始的，0-11月，加1让月份从1-12月区间。
        let d = time.getDate();
        d = d < 10 ? '0' + d : d;
        if (type) {
            let h = time.getHours();
            h = h < 10 ? '0' + h : h;
            let m = time.getMinutes();
            m = m < 10 ? '0' + m : m;
            let s = time.getSeconds();
            s = s < 10 ? '0' + s : s;
            return Y + "-" + M + "-" + d + " " + h + ":" + m + ":" + s;
        } else {
            return Y + "-" + M + "-" + d;
        }
    },
    //时间戳转年月日
    timeFormat(time_,type) {
        const nowtime = new Date();
        const time = new Date(time_);
        let nowY = nowtime.getFullYear();
        let nowM = nowtime.getMonth()+1;
        let nowd = nowtime.getDate();
        let Y = time.getFullYear();
        let M = time.getMonth()+1;
        let d = time.getDate();
        let h = time.getHours();
        h = h < 10 ? '0' + h : h;
        let m = time.getMinutes();
        m = m < 10 ? '0' + m : m;
        let s = time.getSeconds();
        s = s < 10 ? '0' + s : s;
        let str = '';
        if(type==1){
            str =  Y + "年" + M + "月" + d + "日 ";
            if(nowY == Y){
                str =  M + "月" + d + "日 " ;
                if(nowM == M&&nowd == d){
                    str =  '今日';
                }
            }
        }else{
            str =  Y + "年" + M + "月" + d + "日 " + h + ":" + m + ":" + s;
            if(nowY == Y){
                str =  M + "月" + d + "日 " + h + ":" + m + ":" + s;
                if(nowM == M&&nowd == d){
                    str =  '今日' + h + ":" + m + ":" + s;
                }
            }
        }
        return str;
    },
    timeFormatCN(time, format) {
        // console.log(typeof time)
        // if(typeof time)
        var o = {
            "M+": time.getMonth() + 1, //month
            "d+": time.getDate(), //day
            "h+": time.getHours(), //hour
            "m+": time.getMinutes(), //minute
            "s+": time.getSeconds(), //second
            "q+": Math.floor((time.getMonth() + 3) / 3), //quarter
            "S": time.getMilliseconds() //millisecond
        }
        if (/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (time.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }
        }
        return format;
    },
    //时分秒换算
    converS(countTime,type){
        if(!countTime){return '';}
        let day = parseInt(countTime / 60 / 60 / 24)
        let hr = parseInt(countTime / 60 / 60 % 24)
        let min = parseInt(countTime / 60 % 60)
        let sec = parseInt(countTime % 60)
        if(type){
            let str = sec+'秒';
            if(min){
                str = min+'分'+sec+'秒';
            }else if(hr){
                str = hr+'小时'+min+'分'+sec+'秒';
            }else if(day){
                str = day+'天'+hr+'小时'+min+'分'+sec+'秒';
            }
            return  str;
        }else{
            let daystr = day > 9 ? day : '0' + day
            let hrstr = hr > 9 ? hr : '0' + hr
            let minstr = min > 9 ? min : '0' + min
            let secstr = sec > 9 ? sec : '0' + sec
            return daystr+','+hrstr+','+minstr+','+secstr;
        }
    },
    date_getdiffer_date(firstDate, secondDate, differ) {
        //1)将两个日期字符串转化为日期对象
        var startDate = new Date(firstDate);
        var endDate = new Date(secondDate);
        //2)计算两个日期相差的毫秒数
        var msecNum = endDate.getTime() - startDate.getTime();
        //3)计算两个日期相差的天数
        var dayNum = Math.floor(msecNum / this.date_getdiffer_scale(differ));
        //console.log(firstDate + "," + secondDate + "," + differ + "," + dayNum)
        return dayNum;
    },
    date_getdiffer_scale(value) {
        var format;
        //获取转化比（天数跟毫秒数的比例）
        if (value == 1) {
            format = parseFloat(24 * 60 * 60 * 1000);
        }
        //获取转化比（小时数跟毫秒数的比例）
        else if (value == 2) {
            format = parseFloat(60 * 60 * 1000);
        }
        //获取转化比（分钟数跟毫秒数的比例）
        else if (value == 3) {
            format = parseFloat(60 * 1000);
        }
        //获取转化比（秒数跟毫秒数的比例）
        else if (value == 4) {
            format = parseFloat(1000);
        }
        return format;
    },
    // {key:1,val:'正在进行'},{key:0,val:'即将开始'},{key:3,val:'成交'},{key:2,val:'流拍'},{key:5,val:'撤拍'}
    biaodistatusStr(status){
        switch (status) {
            case 0:
                return "即将开始";
            case 1:
                return "正在进行";
            case 2:
                return "已流拍";
            case 3:
                return "已成交";
            case 4:
                return "已暂停";
            case 5:
                return "已撤拍";
            default:
                return "";
        }
    }
    
}